import React, { useEffect, useState } from "react";
import Modal from "@mui/joy/Modal";
import ModalClose from "@mui/joy/ModalClose";
import ModalDialog from "@mui/joy/ModalDialog";
import DialogTitle from "@mui/joy/DialogTitle";
import DialogContent from "@mui/joy/DialogContent";
import DataTable from "react-data-table-component";
import { useForm } from "react-hook-form";
import Select from "react-select";
import toast from "react-hot-toast";
import { getCookie } from "../components/Cookie.jsx";
import { MultiSelect } from "react-multi-select-component";

const customStyles = {
  headCells: {
    style: {
      backgroundColor: "#f1f4f9",
      color: "black",
      fontSize: "0.8rem",
      justifyContent: "center",
      textAlign: "center",
    },
  },
  cells: {
    style: {
      justifyContent: "center",
      textAlign: "center",
    },
  },
};

const NotificationModal = ({ setLayout, layout, modalData, dashboardFn }) => {
  const [clientName, setClientName] = useState("");
  const [timeTag, setTimeTag] = useState("");
  const [imageData, setImageData] = useState([]);
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm();
  const [expandedPanels, setExpandedPanels] = useState([]);
  const [users, setUsers] = useState([]);
  const username = localStorage.getItem("email");
  const token = getCookie("sqa_token");

  const [selectedUsers, setSelectedUsers] = useState([]);
  const messageStatus = watch("messageStatus");

  useEffect(() => {
    if (modalData && modalData?.assignedTo) {
      const preselectedOptions = modalData?.assignedTo?.map((userEmail) => ({
        value: userEmail,
        label: userEmail,
      }));

      setSelectedUsers(preselectedOptions);
    }
  }, [modalData]);

  console.log("users", modalData);
  useEffect(() => {
    if (modalData) {
      const batchIdParts = modalData.batchId
        ? modalData.batchId.split("$")
        : [];
      const client = batchIdParts.length > 0 ? batchIdParts[2] : "";
      const time = batchIdParts.length > 0 ? batchIdParts[1] : "";
      setClientName(client);
      setTimeTag(time);
      getUsers();
      getImage();

      reset({
        title: modalData.title || "",
        batchId: modalData.batchId || "",
        client: client,
        reportedBy: modalData.createdBy || "",
        assignedTo: modalData.assignedTo || "",
        dueDate: modalData.dueDate || "",
        lastAction: modalData.lastAction || "",
        timeTag: modalData.timeTag || "",
        messageStatus: modalData.status || "",
        description: modalData.description || "",
        comment: "",
      });
    }
  }, [modalData, reset]);

  const getImage = async () => {
    const payload = {
      id: modalData?._id,
      filearray: modalData?.file,
    };

    try {
      const response = await fetch("/sqa/api/notification_images/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      setImageData(data?.result[0]);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getUsers = async () => {
    try {
      const url = `/sqa/api/get_all_users/`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (data.result?.length > 0) {
        setUsers(data.result);
      } else {
        setUsers([]);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const onSubmit = async (data) => {
    try {
      // Check for status and due date conditions
      const currentDate = new Date();
      const dueDate = new Date(data.dueDate); // Assuming dueDate is a field in data

      if (data.messageStatus === "overdue" && dueDate > currentDate) {
        toast.error(
          "Cannot select overdue status if due date is in the future."
        );
        return;
      }

      const formData = new FormData();
      formData.append("status", data.messageStatus);
      formData.append("title", data.title);
      formData.append("description", data.description);
      formData.append("comment", data.comment);
      formData.append("assignedTo", data.assignedTo);
      formData.append("createdBy", username);
      formData.append("dueDate", data.dueDate);
      if (data.file && data.file[0]) {
        formData.append("file", data.file[0]);
      }

      const response = await fetch(
        `/sqa/api/notification_update/${modalData._id}`,
        {
          method: "PUT",
          body: formData,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        toast.error(response.message || "Failed to update item.");
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      toast.success("Data updated successfully");
      await response.json();
      await dashboardFn();
      setLayout(undefined);
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to update item.");
    }
  };

  const column = [
    { name: "Comment", selector: (row) => row.comment, sortable: true },
    { name: "By", selector: (row) => row.createdBy, sortable: true },
    { name: "Time", selector: (row) => row.createdAt, sortable: true },
  ];

  const requestIdLabel = modalData?.batchId ? "Batch ID" : "Request ID";
  const clientValue = modalData?.batchId
    ? modalData.batchId.split("$")[2]
    : modalData?.requestId
    ? modalData.requestId.split("$")[0]
    : "N/A";

  const togglePanel = (index) => {
    setExpandedPanels((prevPanels) =>
      prevPanels.includes(index)
        ? prevPanels.filter((i) => i !== index)
        : [...prevPanels, index]
    );
  };

  // const preSelectedOptions = modalData?.assignedTo.map((email) => ({
  //   value: email,
  //   label: email,
  // }));
  return (
    <React.Fragment>
      <Modal
        open={!!layout}
        onClose={() => {
          setLayout(undefined);
          // setSelectedUsers([]);
        }}
      >
        <ModalDialog
          layout={layout}
          sx={{
            margin: "auto",
            width: "80vw",
            height: "90vh",
          }}
        >
          <ModalClose />
          <DialogTitle> Edit Notification Detail</DialogTitle>
          <DialogContent>
            <div className="container mx-auto p-4">
              <form
                onSubmit={handleSubmit(onSubmit)}
                className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 pb-5 txt-xs"
              >
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Title <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                    {...register("title", { required: "Title is required" })}
                  />
                  {errors.title && (
                    <span className="text-red-500">{errors.title.message}</span>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    {requestIdLabel}
                  </label>
                  <input
                    type="text"
                    className="bg-gray-100 border border-gray-300 text-gray-500 text-sm rounded-lg block w-full p-2.5 cursor-not-allowed"
                    value={modalData?.batchId || modalData?.requestId}
                    disabled
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Client
                  </label>
                  <input
                    type="text"
                    className="bg-gray-100 border border-gray-300 text-gray-500 text-sm rounded-lg block w-full p-2.5 cursor-not-allowed"
                    value={clientValue}
                    disabled
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Reported By
                  </label>
                  <input
                    type="text"
                    className="bg-gray-100 border border-gray-300 text-gray-500 text-sm rounded-lg block w-full p-2.5 cursor-not-allowed"
                    value={modalData?.createdBy}
                    disabled
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Assigned To<span className="text-red-500">*</span>
                  </label>
                  {users && users[0] && (
                    <MultiSelect
                      options={users[0]?.map((user) => ({
                        value: user.email,
                        label: user.email,
                      }))}
                      value={selectedUsers} // Bind the component to the state
                      onChange={(selectedOptions) => {
                        setSelectedUsers(selectedOptions); // Update the state when the user selects an option
                        const selectedValues = selectedOptions.map(
                          (option) => option.value
                        );
                        setValue("assignedTo", selectedValues, {
                          shouldValidate: true,
                        });
                      }}
                      labelledBy="Select"
                      overrideStrings={{
                        selectSomeItems: "Select users...", // Custom placeholder text
                        allItemsAreSelected: "All users are selected",
                      }}
                    />
                  )}

                  {/* <Select
                    styles={dropdownStyles}
                    isMulti
                    placeholder={<div>Select user</div>}
                    defaultValue={preSelectedOptions}
                    name="assignedTo"
                    options={users[0]?.map((user, index) => ({
                      value: user.email,
                      label: user.email,
                    }))}
                    onChange={(selectedOptions) => {
                      const selectedValues = selectedOptions.map(
                        (option) => option.value
                      );
                      setValue("assignedTo", selectedValues, {
                        shouldValidate: true,
                      });
                    }}
                    className="basic-multi-select"
                    classNamePrefix="select"
                  /> */}
                  {errors.assignedTo && (
                    <span className="text-red-500">
                      {errors.assignedTo.message}
                    </span>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Due Date
                  </label>
                  <input
                    type="date"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                    min={modalData?.dueDate}
                    defaultValue={modalData?.dueDate || ""}
                    {...register("dueDate")}
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Last Action
                  </label>
                  <input
                    type="text"
                    className="bg-gray-100 border border-gray-300 text-gray-500 text-sm rounded-lg block w-full p-2.5 cursor-not-allowed"
                    value={modalData?.lastAction || "NA"}
                    disabled
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Time Tag
                  </label>
                  <input
                    type="text"
                    className="bg-gray-100 border border-gray-300 text-gray-500 text-sm rounded-lg block w-full p-2.5 cursor-not-allowed"
                    value={timeTag || "N/A"}
                    disabled
                  />
                </div>

                <div>
                  <label className="w-full flex text-sm font-medium text-gray-700">
                    Ticket Status <span className="text-red-500">*</span>
                  </label>
                  <select
                    className={`w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 py-2 px-4 ${
                      messageStatus?.toLowerCase() === "live"
                        ? "bg-purple-100 text-purple-800"
                        : messageStatus?.toLowerCase() === "open"
                        ? "bg-blue-100 text-blue-800"
                        : messageStatus?.toLowerCase() === "overdue"
                        ? "bg-red-100 text-red-800"
                        : "bg-white"
                    }`}
                    value={messageStatus?.toLowerCase()}
                    {...register("messageStatus")}
                  >
                    <option value="open">Open</option>
                    <option value="live">Live</option>
                    <option value="overdue">Overdue</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Add Visuals
                  </label>
                  <input
                    type="file"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                    {...register("file")}
                  />
                </div>
                <div className="col-span-full">
                  <div className="block text-sm font-medium text-gray-700">
                    View Visuals
                  </div>
                  {imageData && imageData.length > 0 ? (
                    imageData.map((file, index) => (
                      <div key={index}>
                        <button
                          type="button"
                          onClick={() => togglePanel(index)}
                          className="w-full text-left py-2 px-4 border border-gray-300 bg-gray-50 rounded-md mt-2"
                        >
                          {file.screenshot_name}
                        </button>
                        {expandedPanels.includes(index) && (
                          <div className="mt-2 p-4 border border-gray-300 rounded-md">
                            <img
                              src={file.screenshot_url}
                              alt={`Image ${index + 1}`}
                              className="w-full h-auto cursor-pointer"
                              onClick={() =>
                                window.open(file.screenshot_url, "_blank")
                              }
                            />
                          </div>
                        )}
                      </div>
                    ))
                  ) : (
                    <p>No files available</p>
                  )}
                </div>

                <div className="col-span-full">
                  <label
                    htmlFor="description"
                    className="block mb-2 text-sm font-medium text-gray-700"
                  >
                    Description <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    id="description"
                    rows="2"
                    className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Write your thoughts here..."
                    {...register("description", {
                      required: "Description is required",
                    })}
                  ></textarea>
                  {errors.description && (
                    <span className="text-red-500">
                      {errors.description.message}
                    </span>
                  )}
                </div>

                <div className="col-span-full">
                  <div style={{ width: "100%" }}>
                    <h1 className="font-bold py-2">Comments</h1>
                    <DataTable
                      columns={column}
                      data={modalData ? modalData.comment : []}
                      pagination
                      defaultSortFieldId={3}
                      defaultSortAsc={false}
                      customStyles={customStyles}
                      fixedHeader="true"
                      fixedHeaderScrollHeight="300px"
                    />
                  </div>

                  <div className="py-2">
                    <label
                      htmlFor="comment"
                      className="block mb-2 text-sm font-medium text-gray-900"
                    >
                      Add Comment
                    </label>
                    <textarea
                      id="comment"
                      rows="1"
                      className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="Add your Comment Here..."
                      {...register("comment")}
                    ></textarea>
                  </div>
                </div>

                <div className="col-span-full text-center">
                  <button
                    type="submit"
                    className="bg-[#4880FF] px-4 py-2 rounded-md text-white hover:bg-blue-600"
                  >
                    Send Message
                  </button>
                </div>
              </form>
            </div>
          </DialogContent>
        </ModalDialog>
      </Modal>
    </React.Fragment>
  );
};

export default NotificationModal;
